import React from "react";
import "./style.css";
import PropTypes from "prop-types";
import { FormControl, FormLabel, Checkbox } from "@chakra-ui/react";

const LabelCheckbox = ({ label = "", name = "", errMessage = "", isChecked = false, isRequired = false, disabled = false, onChange = () => {}, className = "" }) => {
  return (
    <FormControl className="checkbox-field-form-control" isInvalid={errMessage} isRequired={isRequired}>
      <div className="custom-checkbox-cover">
        <FormLabel className="checkbox-field-label">{label || ""}</FormLabel> 
        <Checkbox
          name={name || ""}
          isChecked={isChecked}
          onChange={onChange}
          isDisabled={disabled}
          className={className}
        />
      </div>
    </FormControl>
  );
};

LabelCheckbox.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  isChecked: PropTypes.bool,
  onChange: PropTypes.func,
  errMessage: PropTypes.string,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default LabelCheckbox;